import React, { FC } from 'react';
import ReactPaginate from 'react-paginate';
import { PageSize, Pagination } from './types';

import PreviousPageIcon from '@lmt/unicorn-shared/app/icons/left.svg?react';
import NextPageIcon from '@lmt/unicorn-shared/app/icons/right.svg?react';
import styles from './TablePagination.module.scss';

const previousPage = <PreviousPageIcon />;

const nextPage = <NextPageIcon />;

export const defaultPagination = {
  page: 0,
};

const items = [PageSize.Small, PageSize.Medium, PageSize.Big];

export interface Props {
  pagination: Pagination;
  pageLimitTitle: string;
  totalCount?: number;
  changePagination: (pagination: Pagination) => void;
}

export const TablePagination: FC<Props> = (props) => {
  const { pagination, totalCount, changePagination } = props;

  if (totalCount === 0) {
    return null;
  }

  const currentPage = pagination.page;
  const currentPerPage = pagination.perPage;

  return (
    <div className={styles.container}>
      <div className={styles.rowsCountContainer}>
        <div className={styles.rowsCountTitle}>{props.pageLimitTitle}</div>
        {items.map((perPage) => (
          <div
            onClick={
              currentPerPage === perPage
                ? undefined
                : () =>
                    changePagination({
                      page: defaultPagination.page, // always render first page if Limit is changed
                      perPage: perPage,
                    })
            }
            className={
              currentPerPage === perPage
                ? styles.rowsCountSelected
                : styles.rowsCount
            }
            key={perPage}
          >
            {perPage}
          </div>
        ))}
      </div>
      <div data-test-id="patientListPagination">
        <ReactPaginate
          pageCount={(totalCount ?? 0) / currentPerPage}
          forcePage={currentPage}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          previousLabel={previousPage}
          nextLabel={nextPage}
          breakLabel={'...'}
          breakClassName={styles.break}
          containerClassName={styles.paginationContainer}
          pageLinkClassName={styles.page}
          activeLinkClassName={styles.activePage}
          nextLinkClassName={styles.pageIcon}
          previousLinkClassName={styles.pageIcon}
          onPageChange={(props) => {
            changePagination({
              page: props.selected,
              perPage: currentPerPage,
            });
          }}
        />
      </div>
    </div>
  );
};
